module.exports = __webpack_public_path__ + "static/media/calendarIcon.480f5126.svg";